// src/components/video/ShakaPlayerComponent.tsx
import React, { useEffect, useRef, useState } from "react";

let shaka: any = null;
if (typeof window !== "undefined") {
  shaka = require("shaka-player/dist/shaka-player.compiled.js");
}

interface ShakaPlayerProps {
  playbackUrl: string;
}

const ShakaPlayerComponent: React.FC<ShakaPlayerProps> = ({ playbackUrl }) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!playbackUrl || !shaka || !videoRef.current) return;

    shaka.polyfill.installAll();
    if (!shaka.Player.isBrowserSupported()) {
      setError("Shaka Player is not supported in this browser.");
      return;
    }

    const player = new shaka.Player(videoRef.current);

    player.addEventListener("error", (event: any) => {
      setError("Shaka load error: " + (event.detail ? event.detail : ""));
      console.error("Shaka load error", event);
    });

    player
      .load(playbackUrl)
      .catch((e: any) => {
        setError("Shaka load error: " + (e.message || String(e)));
        console.error("Shaka load error", e);
      });

    return () => {
      player.destroy();
    };
  }, [playbackUrl]);

  if (error) return <div className="text-red-500">{error}</div>;

  return (
    <video
      ref={videoRef}
      controls
      width="100%"
      style={{ maxHeight: 400 }}
      crossOrigin="use-credentials"  // ←これを**必ず追加**
    />
  );
};

export default ShakaPlayerComponent;
